import type { BlockSectionBg } from "./common/types";
import { getSectionBorderClass } from "./blockSection";

type SliderThemeClasses = {
  section: string;
  headline: string;
  body: string;
  border: string;
  paginationDotActive: string;
  paginationDotInactive: string;
  arrow: string;
};

/** Figma block_slider — lite, grey (muted), dark, red. */
const sliderThemeMap: Record<BlockSectionBg, SliderThemeClasses> = {
  light: {
    section: "bg-background text-foreground",
    headline: "text-foreground",
    body: "text-tag-foreground",
    border: getSectionBorderClass("light"),
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
    arrow: "text-foreground",
  },
  default: {
    section: "bg-background text-foreground",
    headline: "text-foreground",
    body: "text-tag-foreground",
    border: getSectionBorderClass("default"),
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
    arrow: "text-foreground",
  },
  muted: {
    section: "bg-muted text-foreground",
    headline: "text-foreground",
    body: "text-tag-foreground",
    border: getSectionBorderClass("muted"),
    paginationDotActive: "bg-foreground",
    paginationDotInactive: "border-foreground/40 bg-transparent",
    arrow: "text-foreground",
  },
  dark: {
    section: "bg-secondary text-secondary-foreground",
    headline: "text-secondary-foreground",
    body: "text-header-top-fg",
    border: getSectionBorderClass("dark"),
    paginationDotActive: "bg-secondary-foreground",
    paginationDotInactive: "border-secondary-foreground/40 bg-transparent",
    arrow: "text-secondary-foreground",
  },
  red: {
    section: "bg-primary text-primary-foreground",
    headline: "text-primary-foreground",
    body: "text-header-top-fg",
    border: getSectionBorderClass("red"),
    paginationDotActive: "bg-primary-foreground",
    paginationDotInactive: "border-primary-foreground/40 bg-transparent",
    arrow: "text-primary-foreground",
  },
};

export function getSliderThemeClasses(
  sectionBg: BlockSectionBg = "light"
): SliderThemeClasses {
  return sliderThemeMap[sectionBg] ?? sliderThemeMap.light;
}
